/**
 * Reclaim is finished when disputes are on and AI evidence automation is on.
 * Shared so the product definition, the picker and the setup checklist all
 * agree — a second predicate elsewhere read `enabled || automateEvidenceEnabled`
 * and so treated a half-finished team as done.
 */
export function isReclaimOnboarded(
  team:
    | {
        settings?: {
          disputes?: {
            enabled?: boolean | null;
            automateEvidenceEnabled?: boolean | null;
          } | null;
        } | null;
      }
    | null
    | undefined,
): boolean {
  const disputes = team?.settings?.disputes;
  return (
    disputes?.enabled === true && disputes.automateEvidenceEnabled === true
  );
}

/**
 * Whether the merchant has begun Reclaim at all. Deliberately an OR against
 * `isReclaimOnboarded`'s AND: "started" is true the moment either flag is set,
 * which is what separates a resumable session from a merchant who has never
 * seen the flow.
 */
export function hasStartedReclaim(
  team:
    | {
        settings?: {
          disputes?: {
            enabled?: boolean | null;
            automateEvidenceEnabled?: boolean | null;
          } | null;
        } | null;
      }
    | null
    | undefined,
): boolean {
  const disputes = team?.settings?.disputes;
  return (
    disputes?.enabled === true || disputes?.automateEvidenceEnabled === true
  );
}
